import { Outlet, useNavigate } from "react-router-dom";
import type { Session, User } from "better-auth"; // Import User and Session types

import { AppSidebar } from "@/components/app-sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { SiteHeader } from "@/components/site-header";
import { Skeleton } from "@/components/ui/skeleton";
import { useEffect } from "react";

interface MainLayoutProps {
  session: { user: User; session: Session } | null; // Update prop type
  isPending: boolean;
}

export function MainLayout({ session, isPending }: MainLayoutProps) {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if session object itself is null
    if (!isPending && session === null) {
      navigate("/login", { replace: true });
    }
  }, [session, isPending, navigate]);

  // Check if session object itself is null
  if (isPending || session === null) {
    return (
      <div className="flex min-h-screen w-full">
        <Skeleton className="hidden h-screen w-64 lg:block" />
        <div className="flex flex-1 flex-col">
          <Skeleton className="h-16 w-full" />
          <Skeleton className="flex-1 p-6 w-full rounded-lg" />
        </div>
      </div>
    );
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <div className="flex flex-1 flex-col">
          <SiteHeader />
          <main className="flex-1 overflow-y-auto pt-4 px-6 pb-6 lg:pt-6 lg:px-8 lg:pb-8">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
